import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import IMultiSelectWidgetProps from "./IMultiSelectWidget";
import { validationCheck } from "../../utils/validation";
import ErrorMessage from "../../components/ErrorMessage";
import { valueResolver } from "../../utils/utils";
import * as dynamicFormActionCreators from "../../components/DynamicForm/actionCreators";
import "../../../assets/sass/widgets/multiSelectWidget.scss";
import { handleEnter, checkForReadOnly } from "../../utils/utils";

interface IMultiSelectWidgetStateProps {
    selectedList?: any;
    errorObj?: any;
}

/**
 * @class MultiSelect
 * @category Widgets
 * @description This component renders list of check box and the output of the selection is an array of the selected item values
 */
class MultiSelectWidget extends React.Component<IMultiSelectWidgetProps, IMultiSelectWidgetStateProps> {
    constructor(props) {
        super(props);
        this.state = {
            selectedList: this.props.value || this.props.schema.default || [],
            errorObj: { error: false, errorMessage: [] },
        };
    }

    componentDidMount = () => {
        const formData = this.props.formData.residentialWarrantyForm;
        const catalogOfAccessoriesFormData = formData?.projectDetails?.shingles?.productContainer?.shingleProductContainer?.catalogofaccessories;
        const MasterFlowProducts = catalogOfAccessoriesFormData?.AtticVentilationContainer?.MasterFlow?.MasterFlowProducts;
        const LowSlopeProducts =   formData?.projectDetails?.addendums?.LowSlopeContainer?.LowSlopeProducts;
        if ( MasterFlowProducts ) {
            sessionStorage.setItem('MasterFlowProducts', JSON.stringify(MasterFlowProducts));
        }
        if ( LowSlopeProducts ) {
            sessionStorage.setItem('LowSlopeProducts', JSON.stringify(LowSlopeProducts));
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { value: prevValue, schema: prevSchema } = prevProps;
        const { value, schema } = this.props;
        if (prevValue !== value) {
            this.setState({ selectedList: value });
        }
        if (prevSchema.const.family !== schema.const.family) {
            this.setState({ errorObj: { error: false, errorMessage: [] } });
        }
    }

    onCheckBoxClick(item) {
        const { onChange, schema } = this.props;
        const { selectedList } = this.state;
        let updatedList = [];
        if (
            schema.items &&
            schema.items.anyOf.some((itemData) => itemData.enum[0] === item) &&
            selectedList &&
            selectedList.includes(item)
        ) {
            // remove an already selected item from the selectedList
            updatedList = selectedList.filter((listItem) => listItem !== item);
        } else {
            // add an item into the selectedList
            if (selectedList) updatedList = [...selectedList];
            updatedList.push(item);
        }

        // error validation
        this.onBlurCheck(updatedList);

        this.setState({
            selectedList: updatedList,
        });
        onChange(updatedList);
    }

    fieldClicked = () => {
        const { removeFieldIdFromStore } = this.props.dynamicFormActions;
        removeFieldIdFromStore(this.props.id);
    };

    onBlurCheck = (output) => {
        const {
            errorSchema,
            schema: {
                const: { family },
            },
            id: propId,
            formData,
        } = this.props;
        const id = propId.split("_");
        const userInput = output.toString();
        const fieldName = propId.split("_")[id.length - 1];
        const validationError = validationCheck(userInput, fieldName, family, errorSchema);
        this.setState({
            errorObj: validationError,
        });
        const dataValidatorPath =
            errorSchema &&
            errorSchema.length &&
            errorSchema.filter((key) =>
                key.parentDependency ? key.key === fieldName && key.parentDependency === family : key.key === fieldName
            );
        // check only for conditionalReverse field validations
        const conditionalReverse =
            dataValidatorPath &&
            dataValidatorPath.length &&
            dataValidatorPath[0] &&
            dataValidatorPath[0].value &&
            dataValidatorPath[0].value.length &&
            dataValidatorPath[0].value.filter((val) => val.validationType === "conditionalReverse");
        if (conditionalReverse && conditionalReverse.length) {
            let value = "";
            let dataValidator = [];
            try {
                dataValidator = JSON.parse(conditionalReverse[0].value);
            } catch (e) {
                dataValidator = [];
            }

            for (let i = 0; i < dataValidator.length; i++) {
                const splitArr = dataValidator[i].node.split("|");
                for (let j = 0; j < splitArr.length; j++) {
                    if (valueResolver(formData, splitArr[j].trim())) {
                        if (valueResolver(formData, splitArr[j].trim()) !== "") {
                            value = value + " " + valueResolver(formData, splitArr[j].trim());
                        }
                    }
                }
                const dependentId = "root_" + dataValidator[i].node.replace(/\./g, "_");
                if (value.trim() === "") {
                    // if dependentNode is not available & currentNode is available
                    this.props.dynamicFormActions.removeFieldIdFromStore(this.props.id);
                    if (userInput) {
                        this.props.dynamicFormActions.addFieldIdToStore({
                            id: dependentId,
                            msg: conditionalReverse[0].messageForDependentNode,
                        });
                        // if dependentNode is not available & currentNode is  not available
                    } else {
                        this.props.dynamicFormActions.removeFieldIdFromStore(dependentId);
                    }
                } else {
                    // if dependentNode is available & currentNode is available
                    this.props.dynamicFormActions.removeFieldIdFromStore(dependentId);
                    if (userInput) {
                        this.props.dynamicFormActions.removeFieldIdFromStore(this.props.id);
                    }
                    // if dependentNode is available & currentNode is not available
                    else {
                        this.props.dynamicFormActions.addFieldIdToStore({
                            id: this.props.id,
                            msg: conditionalReverse[0].message,
                        });
                    }
                }
            }
        }
    };
    /**
     * For old existing warranties on edit --> Showing all items those are in schema
     * For Submitted Warranties checking isSubmittedForm and showing all itmes in schema
     * For New warrranty only showing isDiscon = false items
     */
    getDiscontinuedFilteredItem(itemsList, isSubmittedForm) {
        let optionsToShow = [];
        if ( itemsList && isSubmittedForm) {
            const MasterFlowProducts =  sessionStorage.getItem('MasterFlowProducts') && JSON.parse(sessionStorage.getItem('MasterFlowProducts'));
            const LowSlopeProducts = sessionStorage.getItem('LowSlopeProducts') && JSON.parse(sessionStorage.getItem('LowSlopeProducts'));
            if ( MasterFlowProducts ) {
                const newList = itemsList ? itemsList.filter((option) => (option.const.IsDiscon === false || MasterFlowProducts.includes(option.enum[0]) === true)) : [];
                optionsToShow = newList;
            }
            if ( LowSlopeProducts ) {
                const newList = itemsList ? itemsList.filter((option) => (option.const.IsDiscon === false || LowSlopeProducts.includes(option.enum[0]) === true)) : [];
                optionsToShow = newList;
            }
        } else {
            optionsToShow = itemsList ? itemsList.filter((option) => option.const.IsDiscon === false) : [];
        }
        return optionsToShow;
    }
    

    render() {
        const { schema, id, errorDetails, isSubmittedForm } = this.props;
        const { selectedList, errorObj } = this.state;
        const schemaItemsList =  schema && schema.items && schema.items.anyOf && schema.items.anyOf;
        let itemsList;
        let filteredDiscontinueItems = this.getDiscontinuedFilteredItem(schemaItemsList, isSubmittedForm);
        itemsList = filteredDiscontinueItems && filteredDiscontinueItems.length === 0 ? schemaItemsList : filteredDiscontinueItems ;

        return (
            <>
                <div className="row">
                    {itemsList && itemsList
                        .map((item, index) => (
                            <div
                                key={`multi-select-checkbox-${index}`}
                                className={`${schema.const && schema.const.isWide ? "col-sm-5" : "col-sm-12"}`}
                            >
                                <div className="form-group field field-boolean gaf-multiselect-option">
                                    <label
                                        className={`gaf-checkbox ${
                                            selectedList && selectedList.includes(item.enum[0])
                                                ? "checked"
                                                : "unchecked"
                                        }`}
                                        tabIndex={schema.const.tabIndex}
                                        onKeyPress={handleEnter}
                                    >
                                        <input
                                            checked={selectedList && selectedList.includes(item.enum[0])}
                                            id={`${id}-${index}`}
                                            tabIndex={-1}
                                            type="checkbox"
                                            className="hide-checkbox"
                                            onClick={() => this.fieldClicked()}
                                            onChange={() => this.onCheckBoxClick(item.enum[0])}
                                            disabled={checkForReadOnly(schema.const, isSubmittedForm)}
                                        />
                                    </label>
                                    <label className="checkbox-label">{item.title}</label>
                                </div>
                            </div>
                        ))}
                </div>
                <ErrorMessage errorDetails={errorDetails} errorState={errorObj} propId={id} />
            </>
        );
    }
}

export function mapStateToProps(state) {
    return {
        formData: state.dynamicFormInfo.warrantyInfo,
        errorDetails: state.dynamicFormInfo.errorDetails || {},
        errorSchema: state.dynamicFormInfo.layoutResponse.ErrorSchema || {},
        isSubmittedForm: state.adminData.isSubmittedForm,
    };
}

export function mapDispatchToProps(dispatch) {
    return {
        dynamicFormActions: bindActionCreators(dynamicFormActionCreators, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(MultiSelectWidget);
